<template>
  <div class="flex justify-center items-center flex-col w-full h-full">
    <div style="max-width: 527px" class="mx-auto mb-8 px-4 md:px-8 pt-12 pb-16 md:bg-white md:shadow">
      <!-- logo -->
      <div class="text-center mt-6 md:mt-3 mb-12">
        <img class="inline w-full h-auto" :src="whiteLabel.logoUrl" alt="logo">
      </div>
      <form @submit.prevent="handleVerifiedLogin(accessToken, secret)" class="bg-white shadow md:shadow-none rounded px-5 py-8 md:p-0" novalidate>
        <div class="mb-6 text-grey-dark">
          <h3 class="mb-2">{{ $t('Two-Factor Verification') }}</h3>
          <p>
            <small>
              {{ $t('Two-factor authentication is enabled on this account. Please enter your one-time password code.') }}
            </small>
          </p>
        </div>
        <input-module
          :label="$t('Code')"
          type="text"
          name="email"
          class="mb-4"
          labelClass="mb-2 text-grey-dark-light"
          inputClass="h-12 pl-3 pr-10 text-sm text-grey-darkest"
          v-model="secret"
        />
        <!-- button -->
        <button-module class="w-full py-3">{{ $t('Verify') }}</button-module>
      </form>
    </div>
    <!-- footer -->
    <div class="flex justify-center text-2xs mb-12">
      <img src='@/assets/chrome.png' style="width: 1rem"/>&nbsp;
      <p v-html="$t('Optimized Browser')"></p>
    </div>
    <div class="text-center text-2xs">
      <img class="inline h-12 mb-2" src="@/assets/short-logo.png" alt="footer-logo">
      <p v-html="$t('Powered By Raisr', {'year': new Date().getFullYear()})"></p>
    </div>
  </div>
</template>

<script>
import InputModule from '@/components/form/InputModule'
import ButtonModule from '@/components/shared/ButtonModule'
import LoginMixin from '@/mixins/LoginMixin'

export default {
  components: {
    InputModule,
    ButtonModule
  },
  mixins: [LoginMixin],
  data () {
    return {
      savedUrl: this.$route.params.savedUrl,
      secret: null
    }
  },
  computed: {
    /* Set by loginCallBack just before the push here. Not a prop: Vue Router 4
       drops params that aren't in the route path, so props: true only ever
       handed this component undefined. */
    accessToken () {
      return this.authStore.pendingToken
    }
  }
}
</script>
